import React, { useEffect, useState } from "react";
import { Modal, Radio, Select, Button, notification } from "antd";
import { BookOpen } from "lucide-react";
import {
  assignGuidesToBatch,
  assignGuidesToStudents,
  getJobGuide,
} from "../../../api/globalAdmin/Index";
import WebUtils from "../../../utils/WebUtils";
import Utils from "../../../utils/Utils";

function AssignModal({
  assignPrepGuideModalFlag,
  setAssignPrepGuideModalFlag,
  selectedUserIds,
  setLoading,
  batchDetails,
  studentsData,
}) {
  const userDetail = Utils.getUserDetail();
  const batchId = window.location.pathname.split("/").pop();

  const [assignType, setAssignType] = useState("ALL");
  const [selectedGuides, setSelectedGuides] = useState([]);
  const [jobGuideData, setJobGuideData] = useState([]);

  const getJobGuideData = (id, name, type) => {
    const url = `${getJobGuide}?organizationId=${userDetail.organizationId}`;
    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          //   console.log(result.data.data);
          let data = result?.data?.data;
          setJobGuideData(data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const assignToBatch = () => {
    let url = `${assignGuidesToBatch}?batchIdentifier=${batchId}&organizationId=${userDetail.organizationId}&userIdentifier=${userDetail.userIdentifier}
`;
    // console.log(formData);
    let reqBody = {
      selectedGuides,
    };
    // console.log(reqBody);
    setLoading(true);
    WebUtils.httpOperations(url, selectedGuides, "POST")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          notification.success({
            message: "Success",
            description: `${"Guides assign to batch! "}`,
            placement: "topRight",
            showProgress: true,
            duration: 2,
          });
          setAssignPrepGuideModalFlag(false);
        } else {
          notification.error({
            message: "Failed",
            description: `${result?.data?.resultStatusInfo?.message}`,
            placement: "topRight",
            // showProgress: true,
            duration: 2,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const assignToStudents = () => {
    let url = `${assignGuidesToStudents}`;
    // console.log(formData);
    const selectedObj = studentsData.filter((item) =>
      selectedUserIds.includes(item.userId),
    );
   
    let reqBody = {
      candidateData: selectedObj,
      jodGuideIds: selectedGuides,
      organizationId: userDetail.organizationId,
      userIdentifier: userDetail.userIdentifier,
      batchIdentifier: batchDetails.batchIdentifier,
      batchName: batchDetails.batchName,
    };
    setLoading(true);
    WebUtils.httpOperations(url, reqBody, "POST")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          notification.success({
            message: "Success",
            description: `${"Guides assign to students! "}`,
            placement: "topRight",
            showProgress: true,
            duration: 2,
          });
          setAssignPrepGuideModalFlag(false);
        } else if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "failure"
        ) {
          notification.error({
            message: "Failed",
            description: `${"Guides assign to students failed! "}`,
            placement: "topRight",
            showProgress: true,
            duration: 2,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const handleSubmit = () => {
    if (assignType === "SELECTED") {
      assignToStudents();
    } else {
      assignToBatch();
    }
  };

  const guideOptions = jobGuideData?.map((item) => ({
    label: (
      <div>
        <p className="font-medium mb-0">
          {item.jobTitle}{" "}
          <span className="text-[.75rem] text-gray-500">
            ({item.jobGuideIdentifier})
          </span>
        </p>

        <p className="text-[.75rem] text-gray-500 mb-0">
          Created on{" "}
          {new Date(item.creationTime).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })}
        </p>
      </div>
    ),

    value: item.jobGuideIdentifier,

    title: item.jobTitle,
  }));

  //   console.log(selectedUserIds);

  useEffect(() => {
    getJobGuideData();
  }, []);

  useEffect(() => {
    if (assignPrepGuideModalFlag) {
      if (selectedUserIds?.length > 0) {
        setAssignType("SELECTED");
      } else {
        setAssignType("ALL");
      }
    }
  }, [assignPrepGuideModalFlag, selectedUserIds]);

  return (
    <Modal
      open={assignPrepGuideModalFlag}
      onCancel={() => setAssignPrepGuideModalFlag(false)}
      footer={null}
      centered
      width={550}
      title={
        <div className="flex items-center gap-2">
          <span className="p-[9px] rounded-lg border-[2px] border-gray-200 shadow-sm">
            {" "}
            <BookOpen size={22} color="#475467" />
          </span>
          <div>
            <p className="text-[1rem] font-semibold ">
              Assign preparation guide
            </p>
            <p className="text-[.78rem] font-normal sub-text-color">
              Assign guides to help students prepare for interviews and
              assessments
            </p>
          </div>
        </div>
      }
    >
      <div className="mt-7">
        <Radio.Group
          value={assignType}
          onChange={(e) => setAssignType(e.target.value)}
          className=" custom-orange-radio"
        >
          <Radio value="ALL">Assign guide to all students in this batch</Radio>
          <Radio
            disabled={selectedUserIds?.length < 1}
            value="SELECTED"
            className="mt-2"
          >
            Assign guide to selected student
          </Radio>
        </Radio.Group>
      </div>

      <div className="mt-5">
        <p className="text-[.9rem] font-medium text-[#344054] mb-2">
          Select Guides
        </p>

        <Select
          mode="multiple"
          allowClear
          className="w-full"
          size="large"
          placeholder="Select guides"
          value={selectedGuides}
          onChange={setSelectedGuides}
          options={guideOptions}
          maxTagCount="responsive"
          optionLabelProp="title"
        />
      </div>

      <div className="flex items-center gap-3 mt-6">
        <button
          className="btn-white px-3 py-2 rounded-lg sm:w-1/2 w-full"
          onClick={() => setAssignPrepGuideModalFlag(false)}
        >
          Cancel
        </button>

        <button
          disabled={selectedGuides?.length < 1}
          onClick={handleSubmit}
          className={` ${selectedGuides?.length < 1 ? "btn-disabled" : "btn-orange"} px-3 py-2 rounded-lg sm:w-1/2 w-full`}
        >
          Assign Guide
        </button>
      </div>
    </Modal>
  );
}

export default AssignModal;
